import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import { jsx as _jsx } from "react/jsx-runtime";
function NoTrackedMeetingsEmptyContent(_ref) {
  var isCurrentUser = _ref.isCurrentUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Landmark, {
    icon: "asset-fluidbook",
    children: /*#__PURE__*/_jsx(Text, {
      dimmed: true,
      children: t(isCurrentUser ? 'skills_empty_state_you_have_no_tracked_meetings' : 'skills_empty_state_person_has_no_tracked_meetings')
    })
  });
}
export default NoTrackedMeetingsEmptyContent;